import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private localUrl: string = null;

  private backendUrl: string = environment.url;

  private previewUrl: string = null;

  public uploadedFile = null;

  public fileName: string = null;

  constructor() {}

  private readFileAsDataUrl() {
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.localUrl = event.target.result;
    };
    reader.readAsDataURL(this.uploadedFile);
  }

  public setFile(file: File) {
    this.fileName = file.name;
    this.uploadedFile = file;
    this.readFileAsDataUrl();
  }

  async getImageFromImagePreview() {
    await fetch(this.previewUrl)
      .then((r) => r.blob())
      .then(
        (blobFile) =>
          (this.uploadedFile = new File([blobFile], this.getImageName()))
      );
  }

  public isFileAvailable(): boolean {
    return this.uploadedFile ? true : false;
  }

  public setImagePreview(imageUrl: string) {
    this.previewUrl = this.backendUrl + imageUrl;
    this.getImageFromImagePreview();
  }

  public getImageName() {
    return this.previewUrl?.slice(this.previewUrl?.lastIndexOf('/') + 1);
  }

  public getImagePreview() {
    return this.localUrl ?? this.previewUrl;
  }

  public resetData() {
    this.uploadedFile = null;
    this.localUrl = null;
    this.fileName = null;
    this.previewUrl = null;
  }

  public getFile(): File {
    return this.uploadedFile as File;
  }
}
